var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { BorderLayer } from '../common/Common.styles';
import { HeadlineWithShortTeaser } from './HeadlineWithShortTeaser';
import { ImageWithHeadline } from './ImageWithHeadline';
import { ImageWithHeadlineAndTeaserContainer } from './ImageWithHeadlineAndTeaser.styles';
// utils
import { makeDataTestIdGetter } from '../../../../utils';
export function Tlea3(_a) {
    var { title, subTitle, image, imageTitle, imageSize, backgroundType, customBackground, customParagraph, paragraph, link, imagePosition, children, altText, emphasize = 'title', fontSize, gap, breakPoint, imageStyles, fallbackImg, backgroundColor, dataTestIdPrefix } = _a, rest = __rest(_a, ["title", "subTitle", "image", "imageTitle", "imageSize", "backgroundType", "customBackground", "customParagraph", "paragraph", "link", "imagePosition", "children", "altText", "emphasize", "fontSize", "gap", "breakPoint", "imageStyles", "fallbackImg", "backgroundColor", "dataTestIdPrefix"]);
    const [focused, setFocused] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [tileHeight, setTileHeight] = useState(0);
    const tileRef = useRef(null);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    const setContainerHeight = () => {
        if (tileRef.current === null) {
            return;
        }
        const tilesWidth = Number(window.getComputedStyle(tileRef.current).width.replace('px', ''));
        const br = breakPoint === 'xlarge' ? 'large' : breakPoint;
        switch (br) {
            case 'large': {
                const tilesCount = 3;
                const gapSize = Number(gap.replace('rem', '')) * 16 * (imageSize === 'm' ? 2 : 1);
                const heightL = (tilesWidth - gapSize) / (tilesCount - (imageSize === 'm' ? 0 : 1));
                setTileHeight(heightL);
                break;
            }
            case 'medium': {
                const tilesCount = 2;
                const gapSize = Number(gap.replace('rem', '')) * 16;
                const heightM = (tilesWidth - gapSize) / tilesCount;
                setTileHeight(heightM);
                break;
            }
            default:
                break;
        }
    };
    useEffect(() => {
        setContainerHeight();
    }, [breakPoint]);
    useEffect(() => {
        window.addEventListener('resize', setContainerHeight);
        return () => window.removeEventListener('resize', setContainerHeight);
    }, []);
    return (_jsxs(ImageWithHeadlineAndTeaserContainer, Object.assign({ ref: tileRef, imagePosition: imagePosition, onMouseDown: () => setFocused(false), onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), focused: focused, tabIndex: 0, size: imageSize === 's' ? 'm' : 'l', backgroundType: backgroundType, "data-testid": getDataTestId("image-with-headline-and-teaser-input"), customBackground: customBackground }, rest, { children: [_jsx(ImageWithHeadline, { breakPoint: breakPoint, tileHeight: tileHeight, hovered: hovered, type: "imageWithHeadline", image: image, imageTitle: imageTitle, size: imageSize, altText: altText, imageStyles: imageStyles, fallbackImg: fallbackImg, backgroundColor: backgroundColor }), _jsx(HeadlineWithShortTeaser, Object.assign({ hovered: hovered, tileHeight: tileHeight, backgroundType: backgroundType, customBackground: customBackground, type: "headlineWithShortTeaser", title: title, subTitle: subTitle, size: "s", link: link, fontSize: fontSize, paragraph: paragraph, customParagraph: customParagraph, emphasize: emphasize, previewId: rest.previewId, titlePreviewId: rest.titlePreviewId, isPreview: rest.isPreview }, { children: children })), _jsx(BorderLayer, { className: "gdds-border-layer" })] })));
}
